export default function ContainerNode({
  src: Component,
  ...props
}: any) {
  Component = Component || (()=>(<></>))
  return (
    <Component {...props} />
  );
}
